import { ProductHub } from "./ProductHub";
import { apps } from "./data/products";

export const AppsPage: React.FC = () => {
  return (
    <ProductHub
      eyebrow="Apps"
      heading={
        apps.length === 1
          ? "One app, built and supported by us end to end."
          : `${apps.length} apps, built and supported by us end to end.`
      }
      lede="Everything we ship on the App Store is designed, built, and maintained in-house — no white-label templates, no abandoned first versions."
      products={apps}
      cta="View app"
    />
  );
};
